import React from "react";

export function GananciasModal({
  isOpen,
  onClose,
  title,
  message,
  buttonText = "Cerrar",
  buttonStyle = "is-danger"
}) {
  if (!isOpen) return null;

  return (
    <div className={`modal ${isOpen ? "is-active" : ""}`}>
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button
            className="delete"
            aria-label="close"
            onClick={onClose}
          ></button>
        </header>
        <section className="modal-card-body">{message}</section>
        <footer className="modal-card-foot">
          <button className={`button ${buttonStyle}`} onClick={onClose}>
            {buttonText}
          </button>
        </footer>
      </div>
    </div>
  );
}